// Egypt price display — Stripe-as-Egypt flow charges USD but every UI
// surface shows EGP only. Independent from format.js (SAR/AED).
//
// Launch pricing (Feb 2026):
//   • Main offer:     499 EGP  (was 699 → anchor)
//   • Exit-intent:    399 EGP  (recovery offer, still below the main)
//   • Anchor:         699 EGP  (crossed-out, "سعر الإطلاق / لفترة محدودة")

export const EG_MAIN_EGP = 499;
export const EG_EXIT_EGP = 399;
export const EG_ANCHOR_EGP = 699;
export const EG_ANCHOR_REASON = "سعر الإطلاق / لفترة محدودة";

export function egPrice(amount = EG_MAIN_EGP, { withAnchor = false } = {}) {
  return {
    primary: `${amount} جنيه`,
    primaryNumber: amount,
    currencyShort: "جنيه",
    secondary: null, // No USD anchor for EG
    anchor: withAnchor && amount < EG_ANCHOR_EGP ? `${EG_ANCHOR_EGP} جنيه` : null,
    anchorNumber: withAnchor && amount < EG_ANCHOR_EGP ? EG_ANCHOR_EGP : null,
    anchorReason: withAnchor && amount < EG_ANCHOR_EGP ? EG_ANCHOR_REASON : null,
  };
}
